import { createContext, useContext } from "react";

import type { UserProgressionStateModel } from "@/api/generated/models";

type UserProgressionContextValue = {
  progression: UserProgressionStateModel;
};

const UserProgressionContext =
  createContext<UserProgressionContextValue | null>(null);

export const useUserProgression = () => useContext(UserProgressionContext);

export default UserProgressionContext;
